import React from "react";
import PropTypes from "prop-types";

import DeletedEntriesDialog, { joinNames } from "../common/DeletedEntriesDialog";
import { relationshipLabel } from "./data";

/**
 * "Deleted entries" for Family history — the shared audit dialog
 * (../common/DeletedEntriesDialog, px-matched to Figma 4065:3098) with this
 * section's two rows: Condition / Description.
 *
 * Soft-deleted rows ride along on the same GET payload (`deletedRelatives`),
 * so there is no separate fetch.
 */

const DeletedEntriesModal = ({ patient, entries, onClose }) => (
  <DeletedEntriesDialog
    patient={patient}
    entries={entries}
    subtitle="Family history"
    titleId="fh3-del-title"
    getKey={(r) => r.relativeId}
    // Siblings are passed so the numbering rule ("Brother 1" / "Brother 2")
    // reads inside the dialog exactly as it does in the table.
    getTitle={(r) => relationshipLabel(r, entries)}
    getFields={(r) => [
      ["Condition", joinNames(r.conditions)],
      ["Description", (r.description && r.description.trim()) || "—"],
    ]}
    onClose={onClose}
  />
);

DeletedEntriesModal.propTypes = {
  patient: PropTypes.object,
  entries: PropTypes.array,
  onClose: PropTypes.func.isRequired,
};

export default DeletedEntriesModal;
